<template>
    <section class="odocs-spaced">
        <p>
            <o-tag label="Small" size="small" />
            <o-tag label="Default" />
            <o-tag label="Medium" size="medium" />
            <o-tag label="Large" size="large" />
        </p>
    </section>
</template>
